import {version} from '../../package.json';

export default 'v' + version;
